import { css } from '@backyard-ui/styles';

const ContainerStyles = css({
  position: 'relative',
  boxSizing: 'border-box',
  marginX: 'auto',
  variants: {
    size: {
      xs: {
        maxWidth: 540,
      },
      sm: {
        maxWidth: 720,
      },
      md: {
        maxWidth: 960,
      },
      lg: {
        maxWidth: 1140,
      },
      xl: {
        maxWidth: 1200,
      },
    },
    padding: {
      xs: {
        paddingX: 'calc($1 / 2)',
      },
      sm: {
        paddingX: 'calc($2 / 2)',
      },
      md: {
        paddingX: 'calc($3 / 2)',
      },
      lg: {
        paddingX: 'calc($4 / 2)',
      },
      xl: {
        paddingX: 'calc($5 / 2)',
      },
    },
    isFluid: {
      true: {
        maxWidth: '100%',
      },
    },
  },
  defaultVariants: {
    size: 'md',
    padding: 'lg',
    isFluid: false,
  },
});

export default ContainerStyles;
